"use client";

import type * as React from "react";
import { BookingStepOneContent } from "@/components/booking/BookingStepOneContent";

export const BookingStepOne: React.FC = () => {
  return <BookingStepOneContent />;
};
